import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=26f08c0d&scoped=true&"
import script from "./Confirm.vue?vue&type=script&lang=ts&"
export * from "./Confirm.vue?vue&type=script&lang=ts&"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=26f08c0d&lang=less&scoped=true&"
import style1 from "./Confirm.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f08c0d",
  null
  
)

export default component.exports